import '../Footer/footer.css'
import Logo from '../Assets/logo.webp'
import { FaCalendarAlt, FaInstagram, FaFacebookF, FaTiktok, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import { FaSquareThreads } from "react-icons/fa6";
import { useEventCities } from "../queries/useEventCities";
import { formatDateID, toTitleCase } from "../utils/helper";

export const thisYear = new Date().getFullYear()
export const nextYear = thisYear + 1;

const Footer = () => {

  const { data: kabkota = [], isLoading, isError } = useEventCities();
  if (isLoading) return null;
  if (isError) { console.log("Gagal memuat jadwal: ", isError); return null };

  const cityList = {
    146: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/Uir7gqh2UabnZPBA6"
    },
    9: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/4VDFn8VbwE5bhoyK9"
    },
    13: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/u8U7FW1BKRv1rhYx8"
    },
    69: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/v7Kf8qMoXvTNY6cX9"
    },
    97: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/xD3k1E4LZt29JpFQ8"
    },
    330: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/3N6C98VfZBGRyCMW8"
    },
    104: {
      icon: <FaCalendarAlt />,
      map: "https://maps.app.goo.gl/NoqCZZDBmC7g1aiT8"
    },
  }

  const socialLinks = [
    {
      name: "YouTube",
      url: "https://www.youtube.com/channel/UCA5qiOgJdfMvADpyU7Oz7fQ",
      className: "youtube",
      Icon: FaYoutube,
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/niec_indonesia/",
      className: "instagram",
      Icon: FaInstagram,
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/niec-indonesia/posts/?feedView=all",
      className: "linkedin",
      Icon: FaLinkedinIn,
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/niec.indonesia/?locale=id_ID",
      className: "facebook",
      Icon: FaFacebookF,
    },
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@niec_indonesia/",
      className: "tiktok",
      Icon: FaTiktok,
    },
    {
      name: "Threads",
      url: "https://www.threads.net/@niec_indonesia",
      className: "threads",
      Icon: FaSquareThreads,
    },
  ];

  return (
    <>
      <footer className="footer-area">
        <div className="container">
          <div className="row gap-3 gap-lg-0">
            <div className="col-lg-6">
              <div className="single-footer-widget">
                <h3>Venue Location</h3>

                {kabkota.map((item, index) => {
                  const cityId = item.kabupaten?.id_kabkota;
                  const city = cityList[cityId];

                  return (
                    <p className="location" key={index}>
                      <span className="location-icon">
                        {city?.icon}
                      </span>

                      <a
                        href={city?.map}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="location-text"
                      >
                        {`${formatDateID(item.time_event)} · ${toTitleCase(
                          item.kabupaten.nama_kabkota
                        )} - ${item.place}`}
                      </a>
                    </p>
                  );
                })}

              </div>
            </div>

            <div className="col-lg-6">
              <div className="single-footer-widget">
                <h3>Social Connection</h3>
                <p>
                  Don&apos;t miss Link thing! Receive daily news. You should
                  connect social area for Any Proper Updates Anytime.
                </p>

                <ul className="social-links">
                  {socialLinks.map(({ name, url, className, Icon }) => (
                    <li key={name}>
                      <a
                        href={url}
                        className={className}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={name}
                      >
                        <Icon />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="copyright-area">
                <div className="logo mx-auto">
                  <a href="/">
                    <img
                      src={Logo}
                      alt="logo"
                      width="60"
                      height="38"
                    />
                  </a>
                </div>

                <p>
                  <br />
                  © {thisYear} <a href="https://niecindonesia.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'white', fontWeight: 600 }}>NIEC Indonesia</a>. All Rights Reserved. CV Naresy Indonesia <br />Designed by NIEC IT Team
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
